import reasons from './reasons'
import companies from './companies'
import employees from './employees'
import journeys from './journeys'
import userGroups from './userGroups'
import oncall from './oncall'
import routines from './routines'
import employers from './employers'
import customRules from './customRules'
import approvalsRules from './approvalsRules'
import regions from './regions'
import users from './users'
import usersPerfil from './usersPerfil'
import roleGroups from './roleGroups'
import permissions from './permissions'
import supervisors from './supervisors'
import whbRules from './whbRules'

export default {
  namespaced: true,
  modules: {
    companies,
    employees,
    reasons,
    journeys,
    oncall,
    userGroups,
    routines,
    employers,
    customRules,
    approvalsRules,
    regions,
    users,
    usersPerfil,
    roleGroups,
    permissions,
    supervisors,
    whbRules
  }
}
